import script from "./camera-capture-info.vue?vue&type=script&setup=true&lang=js"
export * from "./camera-capture-info.vue?vue&type=script&setup=true&lang=js"

import "./camera-capture-info.vue?vue&type=style&index=0&id=a623a33a&scoped=true&lang=css"

import exportComponent from "/home/staging-tcms.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a623a33a"]])

export default __exports__